import { AllocationEdition } from 'src/app/_shared/services/allocations/detail/allocation.service';

const stateName = '[ChequesAllocation] ';

export class SharedChequesAllocationGetAction {
    static type = stateName + 'Get Allocation';

    constructor(public allocationId?: number, public options: {force: boolean} = {force: false}) {
    }
}

export class SharedChequesAllocationReloadListAction {
    static type = stateName + 'Reload list';

    constructor(public allocationId: number = null) {
    }
}

export class SharedChequesAllocationSaveAction {
    static type = stateName + 'Save Allocation';

    constructor(public model: AllocationEdition) {
    }
}

export class SharedChequesAllocationDeleteAction {
    static type = stateName + 'Delete Allocation';

    constructor(public allocationId: number) {
    }
}

export class SharedChequesAllocationLoadRelatedListAction {
    static type = stateName + 'Load Related';

    constructor(public activityId: number) {
    }
}
